import styles from "./MapSkeleton.module.css";

/**
 * Placeholder filling the map container while the forecast data loads.
 * Keeps the map area's layout stable so the page doesn't shift once the
 * spots arrive and the real map mounts in its place.
 */
export function MapSkeleton() {
  return <div className={styles.skeleton} aria-hidden />;
}
